export default __webpack_public_path__ + "static/home-cb249c52a4a3ea696ed909bd77613cfa.png";